import { testimonials, socialProof } from '@/lib/marketing-data';
import { Quote, Star } from 'lucide-react';

export function Testimonials() {
  return (
    <section className="py-16 sm:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
            Loved by Engineering Teams
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            See what developers and engineering leaders are saying about ForgeNetwork.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="mt-16 grid gap-8 lg:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="relative rounded-xl border bg-card p-6 sm:p-8"
            >
              {/* Quote Icon */}
              <Quote className="absolute top-6 right-6 h-8 w-8 text-primary/20" />

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="h-5 w-5 fill-yellow-500 text-yellow-500"
                  />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-lg leading-relaxed">
                "{testimonial.quote}"
              </blockquote>

              {/* Author */}
              <div className="mt-6 flex items-center gap-4">
                {/* Fixed: contrast 5.74:1 (was 4.48:1 with text-primary) */}
                <div className="h-12 w-12 rounded-full bg-blue-100 flex items-center justify-center">
                  <span className="text-lg font-semibold text-blue-700">
                    {testimonial.author
                      .split(' ')
                      .map((n) => n[0])
                      .join('')}
                  </span>
                </div>
                <div>
                  <div className="font-semibold">{testimonial.author}</div>
                  <div className="text-sm text-muted-foreground">
                    {testimonial.role}, {testimonial.company}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Social Proof Stats */}
        <div className="mt-16 rounded-xl border bg-muted/30 p-8 sm:p-12">
          <div className="text-center">
            <p className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">
              {socialProof.trustedBy}
            </p>
            {socialProof.logos.length > 0 && (
              <div className="mt-8 grid grid-cols-2 gap-8 sm:grid-cols-4">
                {socialProof.logos.map((logo) => (
                  <div
                    key={logo.name}
                    className="flex items-center justify-center"
                  >
                    <span className="text-lg font-semibold text-muted-foreground/60">
                      {logo.name}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="mt-8 grid grid-cols-3 gap-8 border-t border-border pt-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-primary sm:text-4xl">
                {socialProof.stats.repositories}
              </div>
              <div className="mt-1 text-sm text-muted-foreground">
                Repositories Analyzed
              </div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-primary sm:text-4xl">
                {socialProof.stats.features}
              </div>
              <div className="mt-1 text-sm text-muted-foreground">
                Features Extracted
              </div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-primary sm:text-4xl">
                {socialProof.stats.prds}
              </div>
              <div className="mt-1 text-sm text-muted-foreground">
                PRDs Generated
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
